import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { toast } from 'sonner';

export default function AuthCallback() {
  const navigate = useNavigate();
  const { googleLogin } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash;
    const tokenMatch = hash.match(/token=([^&]+)/);

    if (!tokenMatch) {
      // Check for error in query params
      const params = new URLSearchParams(window.location.search);
      const error = params.get('error');
      if (error) {
        toast.error('Google sign-in failed. Please try again.');
      }
      navigate('/login', { replace: true });
      return;
    }

    const token = tokenMatch[1];

    // Clear the hash immediately
    window.history.replaceState(null, '', window.location.pathname);

    const process = async () => {
      try {
        const user = await googleLogin(token);
        toast.success(`Welcome, ${user.name || 'back'}!`);
        if (user.role === 'super_admin') {
          navigate('/super-admin', { replace: true });
        } else if (!user.restaurant_group_id) {
          navigate('/onboarding', { replace: true });
        } else {
          navigate('/dashboard', { replace: true });
        }
      } catch (err) {
        toast.error(err?.response?.data?.detail || 'Google sign-in failed. Please try again.');
        navigate('/login', { replace: true });
      }
    };

    process();
  }, [navigate, googleLogin]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50">
      <div className="flex flex-col items-center gap-4">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-orange-500" />
        <p className="text-sm text-slate-500">Signing you in...</p>
      </div>
    </div>
  );
}
